<template>
    <Dialog v-model:visible="isVisible" header="OTP Authentication" @hide="hide()" @show="show()" :dismissable="false"
        :draggable="false" :modal="true" :style="{ width: '20vw' }" :closable="false">
        <span v-show="errMessage" class="p-error">{{ errMessage }}</span>

        <div>
            <label class="col-12">
                <center style="color:black;font-weight: bold;">OTP has been sent to {{ this.mailUser }}, please check
                    your
                    email for the OTP</center>
            </label>
            <FormField v-model="OTPCode" fieldClass="col-12">
                <InputText type="number" v-model="this.OTPCode" :placeholder="$t('otp_msg')" style="width:100%;" />
                <template #error>
                    <small v-if="!OTPCode && submitted" class="p-error">{{
        $t('is_required').replace('Value', 'One Time Password') }}
                    </small>
                </template>
            </FormField>
            <Button type="button" class="p-button p-button-success" @click="checkOTP()" label="VERIFY"
                style="width:100%" />
        </div>
        <template #footer>
            <div style="padding-bottom:25px;">
                <center v-if="!this.showLink">
                    Resend OTP in {{ this.countDown }} second<br />
                </center>
                <center>
                    <Button class="p-button p-component p-button-success p-button-text" label="Resend OTP"
                        severity="info" v-if="this.showLink" @click="sendOTP()" style="color: navy;" />
                </center>
            </div>
        </template>
    </Dialog>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
    data() {
        return {
            v$: useVuelidate(),
            errMessage: null,
            url: this.$API_URL + "auth/otp_auth",
            urlSend: this.$API_URL + "auth/send_otp",
            OTPCode: null,
            submitted: false,
            showLink: false,
            countDown: 60
        };
    },
    validations() {
        return {
            OTPCode: { required, minLength: minLength(6) },
        };
    },
    props: {
        model: {
            type: Object,
            default: null,
        },
        userId: {
            type: String,
            default: null,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        initialErrorMessage: {
            type: String,
            default: ""
        },
        mailUser: {
            type: String,
            default: ""
        }
    },
    created() {
        this.countDownTimer()
    },
    methods: {
        show() {
            if (this.initialErrorMessage) {
                this.errMessage = this.initialErrorMessage;
            }
        },
        hide(changeSuccess, message) {
            this.OTPCode = null;
            this.v$.$reset();
            this.errMessage = null;
            this.$emit("update:isVisible", false);
            this.$emit("hide", {
                success: changeSuccess,
                message: message
            });
        },
        passwordClass(data) {
            if (data.showPassword == undefined) {
                data.showPassword = "pi pi-eye";
            }
            data.showPassword =
                data.showPassword == "pi pi-eye-slash" ||
                    data.showPassword == undefined
                    ? "pi pi-eye"
                    : "pi pi-eye-slash";
            return data.showPassword;
        },
        passwordType(data) {
            return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
        },
        checkOTP() {
            this.v$.$validate();
            this.submitted = true;

            var self = this;

            if (!this.v$.$error) {
                this.$emit("block-ui");
                this.v$.$reset();

                if (this.model) {
                    this.model.OTPCode = this.OTPCode;
                }

                this.$axios
                    .post(this.url, {
                        username: this.userId,
                        otp: this.OTPCode,
                    })
                    .then((response) => {
                        if (response.data.success) {
                            self.$emit("update:model", this.model);
                            self.hide(true, response.data.message);
                        } else {
                            this.errMessage = "Failed: " + response.data.message;
                        }
                        this.$emit("unblock-ui");
                    })
                    .catch((err) => {
                        this.$emit("unblock-ui");
                        self.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: err.message,
                            life: 120000,
                        });
                    });
            }
        },
        sendOTP() {
            this.showLink = false;
            this.countDown = 60;

            this.$axios
                .post(this.urlSend, {
                    username: this.userId,
                    otp: this.OTPCode,
                })
                .then((response) => {
                    if (response.data.success) {
                        self.$emit("update:model", this.model);
                        self.hide(true, response.data.message);
                    } else {
                        this.errMessage = "Failed: " + response.data.message;
                    }
                    this.$emit("unblock-ui");
                })
                .catch((err) => {
                    this.$emit("unblock-ui");
                    self.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: err.message,
                        life: 120000,
                    });
                });
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
            else
                this.showLink = true;
        }
    },
    emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
